// extracted by mini-css-extract-plugin
export default {"sideMenuHeader":"SideMenuHeader_sideMenuHeader__I+-vS"};